module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    pre: true,
    attrs: {
      "class": "sky-form-editor"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/vue-loader/lib/template-compiler?{"id":"data-v-644d5e44"}!./scripts/sky-form-editor/sky-form-editor.html
// module id = 270
// module chunks = 1